import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Kurumsal from './pages/Kurumsal';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import KampusOlanaklari from './pages/KampusOlanaklari';
import Iletisim from './pages/Iletisim';
import Anaokulu from './pages/okullarimiz/Anaokulu';
import Ilkokul from './pages/okullarimiz/Ilkokul';
import Ortaokul from './pages/okullarimiz/Ortaokul';
import Lise from './pages/okullarimiz/Lise';
import EtkinliklerGenel from './pages/etkinlikler/etkinliklerGenel';
import EtkinliklerLise from './pages/etkinlikler/etkinliklerLise';
import EtkinliklerOrtaokul from './pages/etkinlikler/etkinliklerOrtaokul';
import EtkinliklerIlkokul from './pages/etkinlikler/etkinliklerIlkokul';
import EtkinliklerAnaokulu from './pages/etkinlikler/etkinliklerAnaokulu';
import BultenDetay from './components/BultenDetay';
import EtkinlikDetay from './components/EtkinlikDetay';
import CardDetay from './pages/CardDetay';

function App() {
  return (
    <Router>
      {/* <Header /> */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:cardId" element={<CardDetay />} />
        <Route path="/kurumsal" element={<Kurumsal />} />
        <Route path="/kurumsal/:bultenId" element={<BultenDetay />} />
        <Route path="/okullarimiz/anaokulu" element={<Anaokulu />} />
        <Route path="/okullarimiz/ilkokul" element={<Ilkokul />} />
        <Route path="/okullarimiz/ortaokul" element={<Ortaokul />} />
        <Route path="/okullarimiz/lise" element={<Lise />} />
        <Route path="/kampus" element={<KampusOlanaklari />} />
        <Route path="/contact" element={<Iletisim />} />
        <Route path="/etkinlikler/anaokulu" element={<EtkinliklerAnaokulu />} />
        <Route path="/etkinlikler/ilkokul" element={<EtkinliklerIlkokul />} />
        <Route path="/etkinlikler/ortaokul" element={<EtkinliklerOrtaokul />} />
        <Route path="/etkinlikler/lise" element={<EtkinliklerLise />} />
        <Route path="/etkinlikler/genel" element={<EtkinliklerGenel />} />
        <Route path="/etkinlikler/:kategoriId/:etkinlikId" element={<EtkinlikDetay />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
